
      // Set title and social meta tags from Vite env var VITE_SITENAME
      const site = import.meta.env.VITE_SITENAME || document.title || 'WeAll'
      document.title = site
      const setMeta = (selector) => {
        const el = document.querySelector(selector)
        if(el) el.setAttribute('content', site)
      }
      setMeta("meta[property='og:title']")
      setMeta("meta[name='twitter:title']")
    